import { useState } from "react";
import { Dateformet, StatusCell } from "../../../component/UserInfoCell";

/**
 * CatlougeSkuOffer component for displaying and managing SKU offers in a drawer UI.
 * Handles drawer state and passes selected row to OfferDrawer.
 */
export const CatlougeSkuOffer = ({ row }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    /**
     * Toggles the drawer and sets the selected row for viewing offers.
     */
    const handleToggleDrawer = (currentRow) => {
        setSelectedRow(currentRow);
        setIsDrawerOpen(true);
    };

    return (
        <>
            <span
                className="symbol symbol-25px cursor-pointer symbol-circle me-2"
                onClick={() => handleToggleDrawer(row)} // Pass the clicked row
            >
                <span className="symbol-label fs-6 fw-semibold text-white bg-success">
                    <i className="bi bi-tags-fill text-white fs-4 fw-semibold"></i>
                </span>
            </span>

            {isDrawerOpen && (
                <OfferDrawer
                    isDrawerOpen={isDrawerOpen}
                    setIsDrawerOpen={setIsDrawerOpen}
                    redemItem={selectedRow} // Pass the selected row
                />
            )}
        </>
    );
};

/**
 * OfferDrawer component for displaying the list of special offers for a SKU in a drawer UI.
 * Handles drawer close and renders offer details table.
 */
const OfferDrawer = ({ isDrawerOpen, setIsDrawerOpen, redemItem, redem_catalouge_id = '' }) => {


    /**
     * Closes the drawer UI.
     */
    const drawerClose = () => {
        setIsDrawerOpen(!isDrawerOpen)
    }
    const drawerStyles = {
        position: "fixed",
        top: 65,
        right: isDrawerOpen ? 0 : "-100%",
        width: "50%",
        height: '100%',
        maxHeight: "calc(100vh - 65px)",
        overflowY: "auto",
        boxShadow: "-2px 0 5px rgba(0, 0, 0, 0.5)",
        backgroundColor: "#fff",
        transition: "right 0.3s ease",
        zIndex: 1000,
    };



    return (
        <>

            <div className="card rounded" style={drawerStyles}>
                <div className="d-flex justify-content-between align-items-center mt-2 px-2 pb-4">
                    <div style={{ border: '1px solid #E6E6E6' }} className="card w-100">
                        <div className="card-header d-flex justify-content-between align-items-center" style={{ minHeight: '39px' }}>
                            <div className="card-title fw-semibold fs-5 py-4">
                                {redemItem?.product_sku?.sku_display_name} / {redemItem?.user_type?.type_name} / Offer List
                            </div>
                            <button
                                onClick={drawerClose}
                                type="button"
                                className="btn btn-danger rounded-circle p-0 d-flex align-items-center justify-content-center fs-1"
                                style={{ width: '25px', height: '25px' }}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="card-body p-3">
                            <table
                                id="kt_table_tm_tree"
                                className="table align-middle table-striped fs-6 gy-5 gx-4 dataTable no-footer"
                                style={{
                                    borderRadius: "5px 5px 0 0",
                                    overflow: "hidden",
                                }}
                            >
                                <thead className="bg-dark text-white p-2 ">
                                    <tr className="text-left text-muted fw-semibolder fs-7 text-uppercase gs-0 ">
                                        <th>Created date</th>
                                        <th>SKU NAME</th>

                                        <th>

                                            <div>
                                                OFFER Detail
                                            </div></th>
                                        <th>STATUS</th>

                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold">
                                    {Array.isArray(redemItem?.redemption_catalogues_special_offers) && redemItem?.redemption_catalogues_special_offers?.length > 0 ? (
                                        redemItem.redemption_catalogues_special_offers.map((item) => (
                                            <tr key={item.id}>
                                                <td>
                                                    <div className="fw-semibold">
                                                        <Dateformet data={item?.created_at} />
                                                    </div>
                                                    <div className="fw-semibold text-danger">
                                                        <Dateformet data={item?.created_at} />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="fw-semibold">
                                                        {redemItem?.product_sku?.sku_display_name}
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="fw-semibold text-success">
                                                        {item?.special_point}
                                                    </div>
                                                    <div className="fw-semibold">
                                                        {item?.special_from_date}
                                                    </div>
                                                    <div className="fw-semibold text-danger">
                                                        {item?.special_to_date}
                                                    </div>

                                                </td>
                                                <td>
                                                    <StatusCell status={item?.status} />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5">
                                                <div className="d-flex text-center w-100 align-content-center justify-content-center">
                                                    No offer found
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>



        </>
    );
};